/**
 * Globo Swatch Fallback
 * If the CDN swatch background-image URL returns a 404, swap it
 * to the original Globo swatch image stored in data-fallback-swatch.
 *
 * Selectors confirmed for this theme:
 *   .spf-product__swatch-image[data-fallback-swatch]
 */
(function () {
  function checkSwatchImages(root) {
    var swatches = (root || document).querySelectorAll(
      '.spf-card-swatch[data-fallback-swatch]'
    );
    swatches.forEach(function (el) {
      var style = el.style.backgroundImage;
      var match = style.match(/url\(['"]?(.*?)['"]?\)/);
      if (!match || !match[1]) return;
      
      var currentUrl = match[1];
      if (el.dataset.swatchChecked === currentUrl) return;
      el.dataset.swatchChecked = currentUrl;

      var img = new Image();
      img.onload = function () { /* CDN image exists — nothing to do */ };
      img.onerror = function () {
        var fallback = el.getAttribute('data-fallback-swatch');
        if (fallback) {
          el.style.backgroundImage = "url('" + fallback + "')";
        }
      };
      img.src = match[1];
    });
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      checkSwatchImages();
    });
  } else {
    checkSwatchImages();
  }

  // Re-run after Globo re-renders (filter / pagination changes)
  window.addEventListener('globoFilterRenderCompleted', function () {
    setTimeout(function () { checkSwatchImages(); }, 300);
  });

  // Re-run whenever new nodes are added to the DOM (e.g. infinite scroll, quick-add)
  var observer = new MutationObserver(function (mutations) {
    var hasNewNodes = mutations.some(function (m) {
      return m.addedNodes.length > 0;
    });
    if (hasNewNodes) checkSwatchImages();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
